export interface InterestedUserPreview {
  userId: string;
  displayName: string;
  photoURL: string;
}

export function useInterestedUsers(_activityId: string): InterestedUserPreview[] {
  // Interest previews are optional. The event document's interestedCount drives
  // the UI count, so do not open the permission-sensitive subcollection here.
  return [];
}
